import Toast from '../components/pages/utils/Toast';
import { API } from '../constants/Constants';
import { DOCUMENT_TOAST } from '../constants/toastConstant';
import Instance from './interceptor';

export const getScanHistoryData = async (
  sorting,
  inputValue,
  filterModel,
  dropDownValue,
  organizationId,
  page,
) => {
  const PAGE_LIMIT = 25;
  const stageValue =
    dropDownValue &&
    Object.keys(dropDownValue)?.length > 0 &&
    dropDownValue?.status?.map((s) => s?.status);
  const documentType =
    dropDownValue &&
    Object.keys(dropDownValue)?.length > 0 &&
    dropDownValue?.document_type?.map((d) => d?.value);
  const data = {
    stage: stageValue,
    searchData: inputValue,
    sortOrder: sorting[0]?.sort,
    sortField: sorting[0]?.colId,
    filterModel,
    organizationId,
    documentType,
    page,
    limit: PAGE_LIMIT,
  };
  try {
    const response = await Instance.post(`${API.GET_SCAN_HISTORY_DATA}`, data);
    const scanHistory = response?.data?.data;

    if (scanHistory?.length === 0) {
      Toast({
        message: DOCUMENT_TOAST.NO_RECORDS,
        variant: 'warning',
        position: { vertical: 'top', horizontal: 'center' },
        autoHideDuration: 4000,
      });
      return scanHistory;
    }
    return scanHistory;
  } catch (error) {
    Toast({ message: `${error?.message}`, variant: 'error' });
  }
};

export const getExportReportData = async (
  sorting,
  inputValue,
  filterModel,
  dropDownValue,
  organizationId,
  page,
) => {
  const PAGE_LIMIT = 25;
  const stageValue =
    dropDownValue &&
    Object.keys(dropDownValue)?.length > 0 &&
    dropDownValue?.status?.map((s) => s?.status);
  const documentType =
    dropDownValue &&
    Object.keys(dropDownValue)?.length > 0 &&
    dropDownValue?.document_type?.map((d) => d?.value);
  const data = {
    stage: stageValue,
    searchData: inputValue,
    sortOrder: sorting[0]?.sort,
    sortField: sorting[0]?.colId,
    filterModel,
    organizationId,
    documentType,
    page,
    limit: PAGE_LIMIT,
  };
  try {
    const response = await Instance.post(`${API.GET_EXPORT_REPORT_DATA}`, data);
    const exportReport = response?.data?.data;

    if (exportReport?.length === 0) {
      Toast({
        message: DOCUMENT_TOAST.NO_RECORDS,
        variant: 'warning',
        position: { vertical: 'top', horizontal: 'center' },
        autoHideDuration: 4000,
      });
      return exportReport;
    }
    return exportReport;
  } catch (error) {
    Toast({ message: `${error?.message}`, variant: 'error' });
  }
};

export const getPaymentHistoryData = async (
  sorting,
  inputValue,
  filterModel,
  // dropDownValue,
  organizationId,
) => {
  const data = {
    // stage: stageValue,
    searchData: inputValue,
    sortOrder: sorting[0]?.sort,
    sortField: sorting[0]?.colId,
    filterModel,
    organizationId,
    // documentType,
  };
  try {
    const response = await Instance.post(
      `${API.GET_ORGANIZATION_PAYMENT_HISTORY}`,
      data,
    );
    const paymentHistory = response?.data?.data;

    if (paymentHistory?.length === 0) {
      Toast({
        message: DOCUMENT_TOAST.NO_RECORDS,
        variant: 'warning',
        position: { vertical: 'top', horizontal: 'center' },
        autoHideDuration: 4000,
      });
      return paymentHistory;
    }
    return paymentHistory;
  } catch (error) {
    Toast({ message: `${error?.message}`, variant: 'error' });
  }
};

export const getScanHistoryChartData = async (organizationId) => {
  const data = {
    organizationId,
  };
  try {
    const response = await Instance.post(API.GET_SCAN_HISTORY_CHART_DATA, data);
    return response?.data?.data;
  } catch (error) {
    Toast({ message: `${error?.message}`, variant: 'error' });
  }
};

export const getScanHistoryAllOrgChartData = async (organizationId) => {
  try {
    const data = {
      organizationId,
    };
    const response = await Instance.post(
      API.ALL_ORGANIZATION_SCAN_HISTORY_CHART_DATA,
      data,
    );
    return response?.data?.data;
  } catch (error) {
    Toast({ message: `${error?.message}`, variant: 'error' });
  }
};

export const getScanHistoryDataSA = async (
  sorting,
  inputValue,
  filterModel,
  filterValue,
  data,
  page,
) => {
  const PAGE_LIMIT = 25;
  const payload = {
    searchData: inputValue,
    sortOrder: sorting[0]?.sort,
    sortField: sorting[0]?.colId,
    filterModel,
    page,
    limit: PAGE_LIMIT,
  };
  try {
    const response = await Instance.post(API.GET_SCAN_HISTORY_DATA_SA, {
      ...payload,
    });
    if (response?.data?.data?.length === 0) {
      Toast({
        message: DOCUMENT_TOAST.NO_RECORDS,
        variant: 'warning',
        position: { vertical: 'top', horizontal: 'center' },
        autoHideDuration: 4000,
      });
      return response?.data?.data;
    }
    return response?.data?.data;
  } catch (error) {
    Toast({ message: `${error?.message}`, variant: 'error' });
  }
};
